<template>
  <div class="page flex-col justify-end">
    <div class="text-wrapper_10 flex-row"><span class="text_1">历史面试</span></div>
    <div class="group_6 flex-row">
      <div class="box_2 flex-row">
        <div class="image-wrapper_7 flex-col">
          <img
            class="thumbnail_8"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPng7bbe81ae109034e3f8da50a5901a7ee935874d196cee98af8fd1adcdfd136819.png"
          />
        </div>
        <span class="text_2">搜索历史面试记录</span>
      </div>
    </div>
    <div class="group_7 flex-row justify-between">
      <div class="section_2 flex-col">
        <div class="image-wrapper_8 flex-col">
          <img
            class="thumbnail_9"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPng2f8376ef072d8731ef0759ac314175f81349de65e0879cbabee91899d239e979.png"
          />
        </div>
        <div class="box_14 flex-col"></div>
        <div class="box_15 flex-col">
          <div class="image-wrapper_9 flex-col">
            <img
              class="thumbnail_10"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPng01135b14fea1a6ed0f1d7a6a8f017e9925d08bd6a28672465f01adabe77a5515.png"
            />
          </div>
        </div>
        <div class="image-wrapper_10 flex-col">
          <img
            class="label_4"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPng8e6cd64a36098966424450b0dad4bd1cc789add12a6963e32d14afbe743b5648.png"
          />
        </div>
        <div class="box_16 flex-col"></div>
        <img
          class="label_5"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng9b1b37eae056aad59317b4268670c0f9a45fa1b35ea31ef836a3198bcdd9f047.png"
        />
        <img
          class="thumbnail_11"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng6831030b72699f6822912a3ebf6445e456d7c581ff003cb6dcf5905d08a227ff.png"
        />
      </div>
      <div class="section_3 flex-col">
        <span class="text_3">今天</span>
        <div class="section_1 flex-row">
          <span class="text_4">面试1</span>
          <div class="group_8 flex-col justify-between">
            <div class="image-wrapper_11 flex-col">
              <img
                class="thumbnail_12"
                referrerpolicy="no-referrer"
                src="./assets/img/SketchPngb115bd869dce206d58f7f73b0c3772428d6104628cdc8d12720c4df288811b2b.png"
              />
            </div>
            <img
              class="thumbnail_13"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPng3453b2913adf09f7c0994fbfcb85e1f7d11664413b99d3ef583946cb15bed246.png"
            />
          </div>
          <div class="group_9 flex-col">
            <div class="section_4 flex-col"></div>
            <div class="image-wrapper_12 flex-row">
              <img
                class="thumbnail_14"
                referrerpolicy="no-referrer"
                src="./assets/img/SketchPng9510823c605416fc90ac85678d1bd4c21fb87079716d1f6291c2681d58696f86.png"
              />
              <img
                class="thumbnail_15"
                referrerpolicy="no-referrer"
                src="./assets/img/SketchPng9510823c605416fc90ac85678d1bd4c21fb87079716d1f6291c2681d58696f86.png"
              />
              <img
                class="thumbnail_16"
                referrerpolicy="no-referrer"
                src="./assets/img/SketchPngc3b9788dc62ba45918018147aa60dabf1fc69cccbc1760069e34b164c87c0a6b.png"
              />
            </div>
          </div>
        </div>
        <img
          class="label_6"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng69ca8e0b3481a9a549219528012548530789e9bb7bb5e5cca1c0312f7bf7d5cf.png"
        />
        <div class="text-wrapper_2 flex-row justify-between">
          <span class="text_5">面试2</span>
          <span class="text_6">13:56</span>
        </div>
        <span class="text_7">11.4</span>
        <div class="text-wrapper_3 flex-row justify-between">
          <span class="text_8">面试1</span>
          <span class="text_9">09:12</span>
        </div>
      </div>
    </div>
    <div class="group_10 flex-row">
      <div class="text-wrapper_4 flex-row justify-between">
        <span class="text_10">面试2</span>
        <span class="text_11">12:09</span>
      </div>
    </div>
    <div class="text-wrapper_11 flex-row"><span class="text_12">11.3</span></div>
    <div class="group_11 flex-row">
      <div class="text-wrapper_6 flex-row justify-between">
        <span class="text_13">面试1</span>
        <span class="text_14">08:34</span>
      </div>
    </div>
    <div class="group_12 flex-row">
      <div class="text-wrapper_7 flex-row justify-between">
        <span class="text_15">面试2</span>
        <span class="text_16">12:09</span>
      </div>
    </div>
    <div class="box_12 flex-col">
      <div class="group_3 flex-col justify-end">
        <span class="text_17">修改名称</span>
        <div class="group_4 flex-row">
          <span class="text_18">面试1</span>
          <div class="box_13 flex-col"></div>
        </div>
        <div class="group_5 flex-row">
          <div class="text-wrapper_8 flex-col"><span class="text_19">取消</span></div>
          <div class="text-wrapper_9 flex-col"><span class="text_20">确认</span></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="css" src="./assets/index.css" />